<template>
  <div class="case-search-condition">
    <div class="case-search-condition-content">
      <div class="full-text-search-warp" v-for="(arr, name) in groupList" :key="name">
        <div class="word-normal word-color2 filter-tag-warp">
          <div class="filter-name">{{ name }}</div>
          <div class="filter-right">
            <span v-for="(i, idx) in arr" class="filter-tag" :key="idx">
              {{ i.tipText }}
              <i
                v-if="remove"
                class="el-icon-close close-btn"
                @click="
                  removeFilter({
                    filterItem: i.filterItem,
                    contentArr: i.contentArr,
                    id: i.id
                  })
                "
              ></i>
            </span>
          </div>
        </div>
        <template v-if="['全文检索', '引用法条'].includes(name) && arr.length > 1">
          <div class="full-text-group-type">
            <div slot="reference" class="group-type-btn">
              <span class="group-text active">{{ getType(name) }}</span>
            </div>
          </div>
          <div class="line">
            <span class="line-item line-item-top"></span>
            <span class="line-item line-item-bottom"></span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchCourseFilterTips } from '@/lib/utils';
import { services } from '@/service';
import { groupBy } from 'lodash';

export default {
  data() {
    return {
      paragraphArr: [],
      groupList: []
    };
  },
  props: {
    list: {
      type: Array,
      required: true
    },
    remove: {
      type: Boolean,
      default: false
    },
    instrumentType: {
      type: String,
      default: ''
    }
  },
  watch: {
    list: {
      handler: function() {
        this.init();
      },
      deep: true
    }
  },
  computed: {
    courseFilterTips() {
      return fetchCourseFilterTips({
        instrumentType: this.instrumentType,
        filterList: this.list,
        paragraphArr: this.paragraphArr,
        hideFilterName: true
      });
    }
  },
  async mounted() {
    this.paragraphArr = await services.labelRelation.getParagraph();
    this.init();
  },
  methods: {
    init() {
      const groupList = groupBy(this.courseFilterTips, 'filterItem.name');
      this.groupList = groupList;
    },
    removeFilter(obj) {
      this.$emit('removeFilter', obj);
    },
    getType(name) {
      const typeEnum = {
        and: '且',
        or: '或',
        must: '且',
        should: '或'
      };
      const item = this.list.find(i => i.name === name && !i.bySearchInput);
      if (item) {
        return typeEnum[item.type];
      } else {
        return '且';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.case-search-condition {
  box-sizing: border-box;
  width: 100%;
  position: relative;
  display: flex;
  line-height: 30px;
  background: #fff;
  justify-content: space-between;
  padding: 10px 20px 20px;

  .case-search-condition-content {
    // max-width: 1200px;
    // margin: 0 auto;
    box-sizing: border-box;
    position: relative;
    // padding: 12px 0;
    transition-duration: 0.3s;
    // display: flex;
    // align-items: flex-start;
    // flex-wrap: wrap;
    // padding-left: 70px;
    height: auto;

    .label {
      position: absolute;
      top: 0;
      left: 0;
    }
    &.is-put {
      height: 80px;
      overflow: hidden;
    }
  }
  .label {
    margin-right: 15px;
  }
  .full-text-search-warp {
    position: relative;
    .full-text-group-type {
      position: absolute;
      left: 80px;
      font-size: 12px;
      top: 50%;
      margin-top: -4px;
      transform: translateY(-50%);
      z-index: 2;
      user-select: none;

      .group-type-btn {
        display: flex;
        flex-direction: column;

        .group-text {
          color: #999999;
          background-color: #f5f5f5;
          line-height: 20px;
          padding: 0 2px;

          &.active {
            color: #e42626;
            background-color: #ffeaea;
          }
        }

        &.not-allowed {
          cursor: not-allowed;
        }
      }
    }

    .line {
      display: inline-block;
      background: #ddd;
      width: 1px;
      position: absolute;
      left: 87px;
      height: calc(100% - 14px);
      top: calc(50% - 4px);
      transform: translateY(-50%);
      .line-item {
        contain: '';
        display: block;
        height: 1px;
        width: 10px;
        background: #ddd;
        position: relative;
      }
      .line-item-top {
        position: absolute;
        top: 0;
      }
      .line-item-bottom {
        position: absolute;
        bottom: 0;
      }
    }
  }

  .filter-tag-warp {
    display: flex;
    flex-direction: row;
  }
  .filter-name {
    display: inline-block;
    width: 110px;
    // color: #2c7ddc;
    color: #1991fb;
  }

  .filter-right {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .filter-tag {
    align-self: baseline;
    word-wrap: break-all;
    padding: 0 10px;
    // padding-right: 28px;
    text-align: left;
    line-height: 26px;
    margin-bottom: 10px;
    color: #3d465a;
    margin-right: 5px;
    background: #f5f5f5;
    border-radius: 4px;
    display: inline-block;
    width: auto;
    .close-btn {
      cursor: pointer;
    }
  }
}
</style>
